export const ROUTE_PATHS = {
  HOME: '/'
} as const;

export const NAV_LINKS = [
  { href: '#hero',      labelEn: 'Home',      labelAr: 'الرئيسية' },
  { href: '#about',     labelEn: 'About',     labelAr: 'عن الشركة' },
  { href: '#products',  labelEn: 'Products',  labelAr: 'المنتجات' },
  { href: '#services',  labelEn: 'Services',  labelAr: 'الخدمات' },
  { href: '#suppliers', labelEn: 'Suppliers', labelAr: 'الموردون' },
  { href: '#market',    labelEn: 'Market',    labelAr: 'السوق' },
  { href: '#contact',   labelEn: 'Contact',   labelAr: 'اتصل بنا' },
];

export interface Product {
  id: string;
  nameAr: string;
  nameEn: string;
  category: string;
  description: string;
  icon: string;
}

export interface Supplier {
  id: string;
  nameAr: string;
  nameEn: string;
  country: string;
  status: 'current' | 'former' | 'network';
  period?: string;
  logo?: string;
}

export interface Stat {
  id: string;
  labelAr: string;
  labelEn: string;
  value: string;
  icon: string;
}

export interface Service {
  id: string;
  titleAr: string;
  titleEn: string;
  description: string;
  icon: string;
}

export interface FinancialData {
  year: number;
  netIncome: number;
}

export const COMPANY_INFO = {
  nameAr: 'شركة القطوف الخضراء',
  nameEn: 'AL-QUTOOF AL-QHADRAA FOR IMPORTING AGRI-MACHINERY AND SPARE PARTS',
  taglineAr: 'رائدون في توريد معدات وقطع غيار الآلات الزراعية في ليبيا',
  taglineEn: 'Leading provider of agricultural machinery and spare parts in Libya',
  foundedYear: '1980s',
  registeredYear: 2014,
  teamSize: 12,
  experienceYears: '40+',
  addresses: [
    {
      id: 'tripoli',
      cityAr: 'طرابلس',
      cityEn: 'Tripoli',
      locationAr: 'النوفليين',
      locationEn: 'Al-Nofleen',
      type: 'administration'
    },
    {
      id: 'almarj',
      cityAr: 'المرج',
      cityEn: 'Al Marj',
      locationAr: 'الطريق الساحلي - ليبيا',
      locationEn: 'Coastal Road - Libya',
      type: 'main'
    }
  ],
  contact: {
    phone: '+218 91 326 8323',
    email: 'import@alqutoof.ly'
  },
  visionAr: 'أن نكون المزود الرائد لقطع غيار الآلات الزراعية عالية الجودة في ليبيا',
  visionEn: 'To be the leading provider of high-quality agricultural machinery parts in Libya',
  missionAr: 'توريد واستيراد مكونات عالية الجودة لدعم القطاع الزراعي الليبي',
  missionEn: 'Source and import high-quality components for Libya\'s agricultural sector',
  historyAr: 'تأسست كورشة إصلاح في الثمانينيات، وتطورت لتصبح شركة استيراد متكاملة. تم التسجيل الرسمي كشركة في عام 2014.',
  historyEn: 'Established as a repair workshop in the 1980s, evolved into a full import company. Formally registered in 2014.'
};

export const PRODUCTS: Product[] = [
  {
    id: 'machinery',
    nameAr: 'الآلات الزراعية',
    nameEn: 'Agricultural Machinery',
    category: 'machinery',
    description: 'حصادات محاصيل (علف/حبوب)، جرارات، محاريث، آلات بذر، آلات كبس القش، رشاشات',
    icon: 'Tractor'
  },
  {
    id: 'spare-parts',
    nameAr: 'قطع الغيار',
    nameEn: 'Spare Parts',
    category: 'parts',
    description: 'قطع غيار أصلية لماركات JOHN DEERE، CLAAS، NEW HOLLAND - محامل، أحزمة، إطارات، شفرات، فلاتر',
    icon: 'Settings'
  },
  {
    id: 'water-pumps',
    nameAr: 'مضخات المياه',
    nameEn: 'submersible pumps',
    category: 'equipment',
    description: 'مضخات مياه أوروبية وتركية عالية الجودة',
    icon: 'Droplet'
  },
  {
    id: 'oils-lubricants',
    nameAr: 'الزيوت والشحوم',
    nameEn: 'Oils & Lubricants',
    category: 'consumables',
    description: 'منتجات SIRAL SPA من مصفاة إيطالية',
    icon: 'Fuel'
  },
  {
    id: 'maintenance',
    nameAr: 'خدمات الصيانة',
    nameEn: 'Maintenance Services',
    category: 'services',
    description: 'صيانة شاملة وإصلاح للآلات الزراعية',
    icon: 'Wrench'
  },
  {
    id: 'authorized-brands',
    nameAr: 'العلامات التجارية المعتمدة',
    nameEn: 'Authorized Brands',
    category: 'brands',
    description: 'موزع معتمد لـ ROSTSELMASH و Özduman، موزع سابق لـ CLAAS',
    icon: 'Award'
  }
];

export const SUPPLIERS: Supplier[] = [
  {
    id: 'rostselmash',
    nameAr: 'روستسيلماش',
    nameEn: 'ROSTSELMASH',
    country: 'Russia',
    status: 'current'
  },
  {
    id: 'ozduman',
    nameAr: 'أوزدومان',
    nameEn: 'Özduman',
    country: 'Turkey',
    status: 'current'
  },
  {
    id: 'claas',
    nameAr: 'كلاس',
    nameEn: 'CLAAS',
    country: 'Germany',
    status: 'former',
    period: '2019-2024'
  },
  {
    id: 'rima',
    nameAr: 'ريما',
    nameEn: 'RIMA',
    country: 'Italy',
    status: 'network',
    logo: '/images/RIMA.jpeg' 
  },
  {
    id: 'tagex',
    nameAr: 'تاجكس',
    nameEn: 'TAGEX',
    country: 'Germany',
  status: 'network',
    logo: '/images/TAGEX.jpeg' 
    },
  {
    id: 'fkl',
    nameAr: 'إف كي إل',
    nameEn: 'FKL',
    country: 'Serbia',
  status: 'network',
    logo: '/images/FKL.jpeg' 
   },
  {
    id: 'sparex',
    nameAr: 'سباركس',
    nameEn: 'SPAREX',
    country: 'England',
  status: 'network',
    logo: '/images/SPAREX.jpeg' 
   }
];

export const STATS: Stat[] = [
  {
    id: 'team',
    labelAr: 'حجم الفريق',
    labelEn: 'Team Size',
    value: '12',
    icon: 'Users'
  },
  {
    id: 'founded',
    labelAr: 'تأسست منذ',
    labelEn: 'Since',
    value: '1980',
    icon: 'Calendar'
  },
  {
    id: 'experience',
    labelAr: 'سنوات الخبرة',
    labelEn: 'Years Experience',
    value: '40+',
    icon: 'TrendingUp'
  },
  {
    id: 'distributors',
    labelAr: 'موزعون معتمدون',
    labelEn: 'Authorized Distributors',
    value: '2',
    icon: 'Award'
  }
];

export const SERVICES: Service[] = [
  {
    id: 'maintenance',
    titleAr: 'الصيانة والإصلاح',
    titleEn: 'Maintenance & Repair',
    description: 'Comprehensive maintenance services for all types of agricultural machinery — seasonal preparation and emergency repairs.',
    icon: 'Wrench'
  },
  {
    id: 'field-visits',
    titleAr: 'زيارات ميدانية',
    titleEn: 'Field Visits',
    description: 'On-site technical support in Alkufra and Al-Sarir — our specialists travel to the project fields.',
    icon: 'MapPin'
  },
  {
    id: 'technical-support',
    titleAr: 'الدعم الفني',
    titleEn: 'Technical Support',
    description: 'Expert technical consultation and operational guidance for machinery selection, setup, and optimisation.',
    icon: 'Headphones'
  }
];

export const FINANCIAL_DATA: FinancialData[] = [
  { year: 2014, netIncome: 677 },
  { year: 2015, netIncome: 792 },
  { year: 2016, netIncome: 871 },
  { year: 2017, netIncome: 914 },
  { year: 2020, netIncome: 745 },
  { year: 2022, netIncome: 980 },
  { year: 2023, netIncome: 1370 },
  { year: 2024, netIncome: 1177 }
];

export const MARKET_DATA = {
  privateFarmers: 25,
  government: 75,
  fieldCircles: 3000,
  hectares: 125000,
  crops: ['قمح', 'شعير'],
  cropsEn: ['Wheat', 'Barley'],
  regions: ['الكفرة', 'السرير'],
  regionsEn: ['Alkufra', 'Al-Sarir']
};